<template>

	<v-content>
		<v-container fluid> 
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Liste yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search" v-model="filterText" label="Ara"></v-text-field>
								<v-btn icon @click="editItem()">
									<v-icon>add_circle</v-icon>
								</v-btn>
							</v-toolbar>
  
							<v-list two-line>
								<template v-for="(item, itemIndex) in getItems"> 
									<v-list-tile :key="itemIndex" avatar >  
										<v-list-tile-avatar>
											<img :src="item.post_image">
										</v-list-tile-avatar>
										<v-list-tile-content @click="editItem(item)" >
											<v-list-tile-title> {{item.name}} </v-list-tile-title>  
											<v-list-tile-sub-title>{{item.post_text}}</v-list-tile-sub-title>
										</v-list-tile-content>
										<v-list-tile-action @click="goItem(item)">
											<v-btn icon ripple>
												<v-icon color="grey lighten-1">remove_red_eye</v-icon>
											</v-btn>
										</v-list-tile-action>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>

 

				<v-dialog v-model="dialogEditor"   max-width="600px">
					<v-card>
						<v-card-title>
							<span class="headline" v-if="item.id">Düzenle</span>
							<span class="headline" v-if="!item.id">Yeni Ekle</span>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-md>
								<v-layout wrap> 
									<v-flex xs12>
										<v-text-field label="Çekiliş Başlığı" v-model="item.name" outline hide-details></v-text-field>
									</v-flex> 
									<v-flex xs12>
										<v-select
											v-model="item.brand_id"
											:items="brands"
											item-text="brand_name"
											item-value="id"
											label="Instagram Hesabı"
											outline
											hide-details
										></v-select>
									</v-flex> 
									<v-flex xs12>
										<v-text-field label="Post URL" v-model="item.post_url" outline  hide-details @paste.prevent="loadingPostInfo"></v-text-field>
									</v-flex>  
									<v-flex xs12 v-if="!isLoadingPostInfo">
										<v-text-field label="Post Image" v-model="item.post_image" outline hide-details disabled readonly></v-text-field>
									</v-flex>  
									<v-flex xs12 v-if="!isLoadingPostInfo">
										<v-text-field label="Post Text" :value="item.post_text" outline hide-details disabled readonly></v-text-field>
									</v-flex>  
									<v-flex xs12 v-if="isLoadingPostInfo">
										<div class="text-xs-center pa-0">
											<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
											<div class="caption mt-4">Post bilgisi alınıyor</div>
										</div>
									</v-flex>  
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions class="pr-4 pl-4 pb-4">
							<v-btn color="error" round outline v-if="item.id" @click="askForRemove()">Sil</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="warning" round outline @click="closeItem()">İptal</v-btn>
							<v-btn color="success" round outline @click="saveItem()">Kaydet</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-dialog v-model="dialogRemove" persistent  max-width="290">
					<v-card> 
						<v-card-text color="error"> Silmek itediğine emin misin ? </v-card-text> 
						<v-card-actions> 
							<v-btn color="green darken-1" flat="flat" @click="closeForRemove()"> Vazgeç </v-btn> 
							<v-spacer></v-spacer>
							<v-btn color="error darken-1" flat="flat" @click="removeItem()"> EMİNİM </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>



			</v-layout>
		</v-container>
	</v-content>


</template>


<script> 
	export default {
		name: "SocialmediaCekilisIndex",
		components : { 
		},
		data() {
			return {
				isLoading : true, 
				isLoadingPostInfo : false, 
				dialogEditor: false,
				dialogRemove: false,
				filterText : "", 
				items : [],
				item: {},
				brands : [],
				 
			}
		},
		mounted(){
			this.loadItems();
		},
		methods : {
			loadItems(){
				this.isLoading = true; 
				this.$http.get( process.env.VUE_APP_API_URL + "/socialmedia/cekilis/", {
					params : { }
				}).then(response => {  
					this.items = response.body;
					this.isLoading = false; 
				}) 
				this.$http.get( process.env.VUE_APP_API_URL + "/socialmedia/cron/brands", {
					params : { }
				}).then(response => {  
					this.brands = response.body;
					this.isLoading = false; 
				}) 
			},
			editItem(item) {
				if (item) {
					this.item = JSON.parse(JSON.stringify(item))
				} else {
					this.item = {
						id: "",
						name: "",
						brand_id: "",
						post_url : "",
						post_id : "",
						post_user_pk : "",
						post_user_username : "",
						post_user_profile : "",
						post_image : "",
						post_text : "",
						count_followers : 0,
						count_likes : 0,
						count_comments : 0,
						count_attachs : 0,
					}
				}
				this.dialogEditor = true;
			},
			goItem(item) { 
				this.$router.push("/socialmedia/cekilis/detail/?id="+item.id)
			},
			closeItem(e) { if (e) { this.loadAccounts(); } this.dialogEditor = false },
			askForRemove() { this.dialogEditor = false; this.dialogRemove = true },
			closeForRemove() { this.dialogEditor = true; this.dialogRemove = false },
			saveItem(){
				this.dialogEditor = false;
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/save", this.item, {
					params: { }
				}).then(response => { 
					this.loadItems();
				})
			},
			removeItem(){
				this.dialogEditor = false;
				this.dialogRemove = false;
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/remove", this.item, {
					params: { }
				}).then(response => { 
					this.loadItems();
				})
			},
			loadingPostInfo(event){ 
				var clipboardData = event.clipboardData || event.originalEvent.clipboardData || window.clipboardData;
				var replacedData = clipboardData.getData('text'); 
				this.isLoadingPostInfo = true;
				this.item.post_url = replacedData;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/postinfo", { post_url : replacedData }, {
					params: { }
				}).then(response => { 
					this.isLoadingPostInfo = false;
					this.item.post_id = response.body.post_id
					this.item.post_user_pk = response.body.post_user_pk
					this.item.post_user_username = response.body.post_user_username
					this.item.post_user_profile = response.body.post_user_profile
					this.item.post_image = response.body.post_image
					this.item.post_text = response.body.post_text
				})
			},
		},
		computed : { 
			getItems(){
				var items = [];
				var filterText = this.filterText.toLowerCase(); 
				items = this.items.filter( function(item) { 
					if( filterText != ""){
						if( item.name.indexOf(filterText) < 0 ){ return false; }
					}
					return true;
				})  
				return items;
			}
		}
	}
</script>

 